/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function ($) {
  'use strict';

  /**
   * Вид для страницы торговой марки "Лас-играс"
   */
  app.LasIgrasView = app.View.extend({
    el: 'body',

    events: {
      'click .js-scroll-link': 'scrollToId',
      'click .js-li-filter': 'onFilterClick',
    },
    /**
     * @inheritDoc
     */
    run: function () {
      this.childViews = {};

      this.childViews.topForm = new app.CallMeView({
        el: '#callme-form-top',
        initiatorSelector: '.las-phone input',
        formElement: '.las-input',
        settlement: this.settlement,
      });
      this.childViews.bottomForm = new app.CallMeView({
        el: '#callme-form-bottom',
        initiatorSelector: '.button',
        formElement: '.las-input',
        settlement: this.settlement,
      });

      /**
       * Когда готов app.filterData, парсим для получения информации
       * по фильтрам "Игры для взрослых", "Семейные игры"
       */
      this.listenToOnce(Backbone, 'las-igras-set-filter-data', this.prepare);

      this.listenTo(this.childViews.topForm, 'error', this.resizeBlock);
      this.listenTo(this.childViews.topForm, 'success', this.resizeBlock);
    },

    /**
     * Прокрутка экрана до элемента, айди которого хранится в data-scroll-to ссылки
     * @param e
     */
    scrollToId: function (e) {
      e.preventDefault();
      var thisLinkData = $(e.currentTarget).data('scroll-to'),
        $htmlBody = $('html, body'),
        filterData = $(e.currentTarget).data('apply-filter');

      $htmlBody.animate({scrollTop: this.$('#' + thisLinkData).offset().top}, 500);
      if (filterData) {
        this._applyFilter(filterData);
      }
    },

    /**
     * Сохранить ссылки на объекты фильтров и вывести количество товаров по фильтрам
     * @param data {Object}
     * @param count {Object}
     */
    prepare: function (data, count) {
      var that = this;
      this.filterData = data;
      _.each(count, function (value, key) {
        that.drawFilteredCount('js-'+ key + '-counter', count[key]);
      });
    },

    /**
     * Вывести количество товара 'count' в элемент с селектором 'selector'
     * @param selector
     * @param count
     */
    drawFilteredCount: function (selector, count) {
      $('.' + selector).html(count);
    },

    /**
     * Обработка клика по ссылкам "Игры для взрослых", "Семейные игры"
     * @param event
     */
    onFilterClick: function (event) {
      event.preventDefault();
      this._applyFilter($(event.currentTarget).data('type'), event);
    },

    /**
     * Применение фильтра
     * @param type (adult, infant, null)
     * @param event
     * @private
     */
    _applyFilter: function (type, event) {
      var filterButtons = this.$('.js-li-filter');
      filterButtons.removeClass('selected');
      if (type && this.filterData) {
        filterButtons.filter('js-' + type).addClass('selected');
        Backbone.trigger('backbone-filter-apply', event, this.filterData[type]);
      }
    },

    /**
     *  Увеличение блока las-callme-form-spacer, если есть поля с ошибками в верхней форме.
     *  Уменьшение, если ошибок нет
     */
    resizeBlock: function () {
      var spacer = this.$el.find('.las-callme-form-spacer');

      if (this.childViews.topForm.$el.find('input.error').length > 0) {
        spacer.addClass('las-callme-form-spacer_extended');
      } else {
        spacer.removeClass('las-callme-form-spacer_extended');
      }
    }
  });
})(jQuery);

}.call(window));